module.exports = __webpack_public_path__ + "img/DNMAdvisory.2f3b0a75.jpg";